import { Content } from 'src/app/models/content';
import { Form } from "src/app/models/form";
import { FormPropertyKey } from "src/app/models/form-property-key";

export class FormOverlay extends Content{

  legacy:boolean = false; // 旧フォームの場合:true ※trueの場合、変更不可、保存しない
  // formHash:string;
  
  hash:string; 
  type:'FormOverlay';
  typeText:string = 'フォーム（オーバーレイ）';

  form:Form;

  constructor(object = null){
    super();

    this.type = 'FormOverlay';

    if(object){
      super.set(object);
      this.set(object);
    }
  };

  set(object){

    if(object.legacy){
      this.legacy = object.legacy;
    }
    if(object.form?.hash){
      // this.formHash = object.formHash;
      this.hash = object.form.hash;
  }

  if(! this.form){
    this.form = new Form();
  }

  this.form.setObject(object.form);
  }

  getFormDatasObject(){
    const values = {};
    this.form.formPropertyKeys.forEach((formPropertyKey:FormPropertyKey) => {
      values[formPropertyKey.id] = formPropertyKey.value;
    });
    return values;
  }

}